import React, { useMemo } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Box, IconButton, Tooltip, CircularProgress } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BlockIcon from '@mui/icons-material/Block';
import { tableConfig } from '../../../../commons/table/config/tableConfig';

const AgenciasTable = ({ data, loading, onEdit, onToggleStatus }) => {
    const columns = useMemo(
        () => [
            {
                accessorKey: 'razonSocial',
                header: 'Razón Social',
            },
            {
                accessorKey: 'telefono',
                header: 'Teléfono',
            },
            {
                accessorKey: 'mail',
                header: 'Mail',
            },
            {
                accessorKey: 'direccion',
                header: 'Dirección',
            },
            {
                id: 'estado',
                header: 'Estado',
                Cell: ({ row }) => {
                    const isActivo = row.original.activo;
                    return (
                        <Box
                            component="span"
                            sx={{
                                backgroundColor: isActivo ? '#e8f5e9' : '#ffebee',
                                color: isActivo ? '#2e7d32' : '#c62828',
                                borderRadius: '10px',
                                padding: '3px 9px',
                                fontSize: '11px',
                                display: 'inline-block'
                            }}
                        >
                            {isActivo ? 'Activa' : 'Inactiva'}
                        </Box>
                    );
                }
            }
        ],
        []
    );

    const table = useMaterialReactTable({
        ...tableConfig,
        columns,
        data: data || [],
        state: { isLoading: loading },
        enableColumnActions: true,
        enableColumnFilters: true,
        enableRowActions: true,
        positionActionsColumn: 'last',
        renderRowActions: ({ row }) => (
            <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                <Tooltip title="Editar">
                    <IconButton size="small" color="primary" onClick={() => onEdit(row.original)}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title={row.original.activo ? 'Desactivar' : 'Activar'}>
                    <IconButton 
                        size="small" 
                        color={row.original.activo ? 'error' : 'success'} 
                        onClick={() => onToggleStatus(row.original)}
                    >
                        {row.original.activo ? <BlockIcon fontSize="small" /> : <CheckCircleIcon fontSize="small" />}
                    </IconButton>
                </Tooltip>
            </Box>
        ),
    });

    return <MaterialReactTable table={table} />;
};

export default AgenciasTable;
